import * as yup from 'yup';

export const addressValidationSchema = yup.object().shape({
  streetAddress: yup.string().required("Street Address is required"),
  streetAddress2: yup.string().notRequired(),
  city: yup.string().required("City is required"),
  postalCode: yup.string().required("Postal Code is required"),
  regionId: yup.number().required("Region is required"),
});
